import { createChildPath } from '../../../utils';
import generateAsyncRouteComponent from '../../../generateAsyncRouteComponent';

export default {
  path: createChildPath('payment-methods'),
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/PaymentAuthenticated'),
  }),
};
